function initProductGallery(galleryId) {
  var gallery = document.getElementById(galleryId);
  if (!gallery) return;
  if (gallery.dataset.galleryReady === 'true') return;
  gallery.dataset.galleryReady = 'true';

  var mainContainer = document.getElementById(galleryId + '-main');
  var track = document.getElementById(galleryId + '-track');
  var thumbsContainer = document.getElementById(galleryId + '-thumbs');
  var counterCurrent = document.getElementById(galleryId + '-current');
  var slides = track ? track.querySelectorAll('.gallery-opt__slide') : [];
  var thumbs = thumbsContainer ? thumbsContainer.querySelectorAll('.gallery-opt__thumb') : [];
  var zoomEl = mainContainer ? mainContainer.querySelector('.gallery-opt__zoom') : null;
  var currentIndex = 0;
  var isDesktop = window.innerWidth >= 1000;
  var isScrolling = false;

  function loadSlideImage(slide) {
    if (!slide) return;
    var image = slide.querySelector('img.gallery-opt__main-media');
    if (!image) return;
    image.setAttribute('loading', 'eager');
    image.setAttribute('fetchpriority', 'high');
    if (image.dataset.srcset) {
      image.srcset = image.dataset.srcset;
      delete image.dataset.srcset;
    }
    if (image.dataset.src) {
      image.src = image.dataset.src;
      delete image.dataset.src;
    }
  }

  function activateSlideVideo(slide) {
    slides.forEach(function(item) {
      var itemVideo = item.querySelector('video.gallery-opt__main-media');
      if (itemVideo && item !== slide) itemVideo.pause();
    });

    if (!slide) return;
    var video = slide.querySelector('video.gallery-opt__main-media');
    if (!video) return;
    var attachedSource = false;
    video.querySelectorAll('source[data-src]').forEach(function(source) {
      source.src = source.dataset.src;
      delete source.dataset.src;
      attachedSource = true;
    });
    if (attachedSource) video.load();
    if (video.dataset.galleryAutoplay === 'true') {
      video.play().catch(function() {});
    }
  }

  // Find initial active index
  slides.forEach(function(slide, i) {
    if (slide.classList.contains('is-active')) currentIndex = i;
  });

  function scrollTrackTo(index) {
    if (!track || !slides[index]) return;
    isScrolling = true;
    var slideWidth = slides[index].offsetWidth;
    track.scrollTo({ left: slideWidth * index, behavior: 'smooth' });
    // Reset scrolling flag after animation completes
    setTimeout(function() { isScrolling = false; }, 400);
  }

  function setActive(index, skipScroll) {
    if (index < 0 || index >= slides.length) return;
    currentIndex = index;

    loadSlideImage(slides[index]);
    activateSlideVideo(slides[index]);

    // Desktop: toggle is-active class (only one visible at a time)
    if (isDesktop) {
      slides.forEach(function(s) { s.classList.remove('is-active'); });
      slides[index].classList.add('is-active');
    }

    // Update thumbnails
    thumbs.forEach(function(t) { t.classList.remove('is-active'); });
    if (thumbs[index]) {
      thumbs[index].classList.add('is-active');
      // Scroll active thumb into view on mobile
      if (!isDesktop) {
        thumbs[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }

    // Update counter
    if (counterCurrent) counterCurrent.textContent = index + 1;

    // On mobile, scroll the main track to the correct slide
    if (!isDesktop && !skipScroll) {
      scrollTrackTo(index);
    }
  }

  // Mobile: detect which slide is visible after user drags
  if (track && slides.length > 1) {
    var scrollTimer;
    track.addEventListener('scroll', function() {
      if (isDesktop || isScrolling) return;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function() {
        var slideWidth = slides[0].offsetWidth;
        var scrollLeft = track.scrollLeft;
        var closest = Math.round(scrollLeft / slideWidth);
        closest = Math.max(0, Math.min(closest, slides.length - 1));
        if (closest !== currentIndex) {
          setActive(closest, true); // skipScroll=true since user already scrolled
        }
      }, 80);
    }, { passive: true });

    if ('IntersectionObserver' in window && !isDesktop) {
      var imageObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          loadSlideImage(entry.target);
          imageObserver.unobserve(entry.target);
        });
      }, { root: track, rootMargin: '0px 100% 0px 100%', threshold: 0.01 });
      slides.forEach(function(slide) { imageObserver.observe(slide); });
    }
  }

  // Thumbnail click — works on both mobile and desktop
  if (thumbsContainer) {
    thumbsContainer.addEventListener('click', function(e) {
      var thumb = e.target.closest('.gallery-opt__thumb');
      if (!thumb) return;
      var index = parseInt(thumb.dataset.index) - 1; // data-index is 1-based
      setActive(index);
    }, { passive: true });
  }

  // Keyboard navigation
  gallery.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      e.preventDefault();
      if (currentIndex + 1 < slides.length) setActive(currentIndex + 1);
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      e.preventDefault();
      if (currentIndex - 1 >= 0) setActive(currentIndex - 1);
    }
  });

  // Zoom button – open full-res image overlay
  if (zoomEl) {
    zoomEl.addEventListener('click', function() {
      var activeSlide = slides[currentIndex];
      if (!activeSlide) return;
      var img = activeSlide.querySelector('img');
      if (!img) return;
      var zoomSrc = img.dataset.zoomSrc || img.src;
      if (!zoomSrc) return;

      var overlay = document.createElement('div');
      overlay.style.cssText = 'position:fixed;inset:0;z-index:9999;background:rgba(0,0,0,.92);display:flex;align-items:center;justify-content:center;cursor:zoom-out;animation:galleryFadeIn .2s ease';
      overlay.innerHTML = '<img src="' + zoomSrc + '" style="max-width:95vw;max-height:95vh;object-fit:contain;border-radius:4px" alt="">' +
        '<button style="position:absolute;top:16px;right:16px;background:rgba(255,255,255,.9);border:none;width:36px;height:36px;border-radius:50%;font-size:20px;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#000" aria-label="Close">&times;</button>';

      function closeOverlay() { overlay.remove(); }
      overlay.addEventListener('click', closeOverlay);
      document.addEventListener('keydown', function handler(e) {
        if (e.key === 'Escape') { closeOverlay(); document.removeEventListener('keydown', handler); }
      });
      document.body.appendChild(overlay);
    });
  }

  // Handle resize
  window.addEventListener('resize', function() {
    var wasDesktop = isDesktop;
    isDesktop = window.innerWidth >= 1000;
    if (wasDesktop !== isDesktop) {
      setActive(currentIndex);
      if (!isDesktop && track && slides[currentIndex]) {
        track.scrollLeft = slides[currentIndex].offsetWidth * currentIndex;
      }
    }
  });

  // Preload adjacent images on desktop
  thumbs.forEach(function(thumb, i) {
    thumb.addEventListener('mouseenter', function() {
      var adjacentSlide = slides[i];
      if (adjacentSlide) {
        loadSlideImage(adjacentSlide);
      }
    });
  });

  setActive(currentIndex, true);
  if (!isDesktop && track && slides[currentIndex]) {
    track.scrollLeft = slides[currentIndex].offsetWidth * currentIndex;
  }
}

// Auto-initialize all gallery instances on the page
document.querySelectorAll('[data-gallery-optimized]').forEach(function(el) {
  initProductGallery(el.dataset.galleryOptimized);
});
